import { render, staticRenderFns } from "./WorkspaceVersionsTab.vue?vue&type=template&id=5e5ba8fe&scoped=true"
import script from "./WorkspaceVersionsTab.vue?vue&type=script&lang=js"
export * from "./WorkspaceVersionsTab.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceVersionsTab.vue?vue&type=style&index=0&id=5e5ba8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5ba8fe",
  null
  
)

export default component.exports